import React from "react";
import bgImg2 from "./../../images/bg_3.jpg";
const ClinicalFacts = () => {
  return (
    <>
      <div
        className="bg-cover bg-no-repeat bg-center  w-full h-80"
        style={{
          backgroundImage: `url(${bgImg2})`,
        }}
      >
        <div className="opacity-80 absolute bg-black  w-full h-80"></div>
        <div className="container relative py-8 text-center text-white">
          <h1 className="text-4xl py-2 font-Poppins font-semibold">
            Faktet <span className="text-primary">Klinike</span> Tona
          </h1>
          <p>
            Nëse buzëqeshja juaj nuk ju përshtatet, atëherë duhet të vini tek ne!
          </p>
          <div className="flex justify-between items-center py-16">
            <div className="">
              <h1 className="text-4xl font-Poppins font-extrabold">08</h1>
              <p className="text-secondary italic text-2xl font-Roboto font-semibold">
                Vite Eksperiencë
              </p>
            </div>

            <div className="">
              <h1 className="text-4xl font-Poppins font-extrabold">500</h1>
              <p className="text-secondary italic text-2xl font-Roboto font-semibold">
                Klientë të Lumtur
              </p>
            </div>

            <div className="">
              <h1 className="text-4xl font-Poppins font-extrabold">100%</h1>
              <p className="text-secondary italic text-2xl font-Roboto font-semibold">
                Kenaqësi
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClinicalFacts;
